import { render, staticRenderFns } from "./StocksPage.vue?vue&type=template&id=708ac522&"
import script from "./StocksPage.vue?vue&type=script&lang=ts&"
export * from "./StocksPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports